import { createSelector } from 'reselect';
import { CustomerType } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';

export const getCustomers = (state: RootState) => state.customers.customers;
export const getSelectedCustomerId = (state: RootState) => state.customers.selectedCustomerId;
export const getSelectedCustomerPricelists = (state: RootState) => state.customers.customerPricelists;
export const getSelectedCustomerPricelistPeriods = (state: RootState) =>
    state.customers.customerPricelistPeriods;

export const getBusinessChains = createSelector([getCustomers], customers =>
    Object.values(customers).filter(c => c.customerType === CustomerType.HQ)
);

export const getSelectedCustomer = createSelector(
    [getSelectedCustomerId, getCustomers],
    (selectedCustomerId, customers) => (selectedCustomerId != null ? customers[selectedCustomerId] : null)
);

export const getCustomerUi = (state: RootState) => state.customers.ui;

export const getPurchasers = (state: RootState) => state.customers.purchasers;